import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AuthenticationService } from '../../../../shared/services/authentication.service';

@Component({
  selector: 'app-pda-inv-main',
  templateUrl: './pda-inv-main.component.html',
  styleUrls: ['./pda-inv-main.component.scss']
})
export class PdaInvMainComponent implements OnInit {
  title: string;

  constructor(private location: Location,  
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void { }

  goBack(): void {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/inventory/main/pda-inv-main.component.ts